<template>
  <v-card :disabled="isProcessing" :loading="isProcessing">
    <template v-slot:progress>
      <v-progress-linear
        absolute
        color="success"
        height="4"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-tabs v-model="tab" class="deep-gl" left dark icons-and-text>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1">
        <v-toolbar-title>{{ $t("ALIASES.LIST") }}</v-toolbar-title>
      </v-tab>
      <v-spacer></v-spacer>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text class="pa-0">
            <Table
              v-if="userStatePrepared"
              ref="aliases-table"
              height="500"
              name="aliases-table"
              :headers="headers"
              :hidden-headers="hiddenHeaders"
              :blink-row-item-key="blinkRowItemKey"
              :server-data-options="{
                method: tableItemsMethod
              }"
              :items-per-page="100"
              :loading="isProcessing"
              dense
              fixed-header
              multi-sort
              filterable
            >
              <template
                v-for="(header, index) in columnHeaders"
                v-slot:[`item.${header.value}`]="{ item }"
              >
                <TableRowActions
                  v-if="header.value === 'options'"
                  :key="index"
                  :show-delete="false"
                >
                  <template #edit>
                    <v-btn
                      v-if="hasPermissions('aliases-edit')"
                      icon
                      color="primary"
                      @click="handleEditClick(item.item.id)"
                    >
                      <v-icon dark>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                </TableRowActions>
                <template v-else>
                  {{ item.value ?? "-" }}
                </template>
              </template>
            </Table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import Table from "@/views/partials/v-table/Table.vue";
import TableRowActions from "@/views/partials/v-table/components/TableRowActions.vue";
import { GET_ALIASES } from "@/store/aliases.module";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import userStateService from "@/common/userState.service.js";

export default {
  name: "ShowAliases",
  components: {
    Table,
    TableRowActions,
  },
  data() {
    return {
      tableName: "aliases-table",
      blinkRowItemKey: null,
      userStatePrepared: false,
      tab: "tab-1",
      isProcessing: false,
      tableItemsMethod: GET_ALIASES,
      headers: [
        {
          text: "#",
          value: "id",
          align: "center",
          width: "8%",
        },
        {
          text: this.$t("GENERAL.LABELS.NAME"),
          value: "name",
          align: "center",
          width: "40%",
        },
        {
          text: this.$t("ALIASES.TABLE_COLUMNS.NUMBER_OF_TYPE"),
          value: "types",
          align: "center",
          width: "20%",
        },
        {
          text: this.$t("GENERAL.TABLE.OPTIONS_COLUMN"),
          value: "options",
          sortable: false,
          align: "center",
          width: "10%",
        },
      ],
      hiddenHeaders: [],
    };
  },
  computed: {
    columnHeaders() {
      return [...this.headers, ...this.hiddenHeaders];
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("ALIASES.LIST") },
    ]);

    this.blinkRowItemKey = userStateService.getState(
      `table-state.${this.tableName}.blinkRowItemKey`,
      null
    );

    const selectedHiddenHeadersKey = `table-state.${this.tableName}.selectedHiddenHeaders`;
    const selectedHiddenHeadersInitializedKey = `table-state.${this.tableName}.selectedHiddenHeadersInitialized`;

    if (!userStateService.getState(selectedHiddenHeadersInitializedKey, false)) {
      userStateService.setState(selectedHiddenHeadersKey, [...this.hiddenHeaders]);
      userStateService.setState(selectedHiddenHeadersInitializedKey, true);
    }

    this.userStatePrepared = true;
  },
  methods: {
    handleEditClick(id) {
      userStateService.setState(
        `table-state.${this.tableName}.blinkRowItemKey`,
        id
      );

      this.$router.push({ name: "edit-alias", params: { id } });
    },
  },
};
</script>
